import { observer } from "mobx-react-lite";
import React from "react";
import { View, XStack } from "tamagui";
import { CreateWizardBack } from "./CreateWizardBack";
import {
  CREATE_WIZARD_STEPS,
  type CreateWizardState,
} from "./CreateWizardState";

export const CreateWizardProgress: React.FC<{ state: CreateWizardState }> =
  observer((props) => {
    const dots = React.useMemo<
      { completed: boolean; step: number; active: boolean }[]
    >(() => {
      const steps = Object.keys(CREATE_WIZARD_STEPS);

      const currentStepIndex = props.state.getActiveStepIndex();

      return steps.map((_s, i) => {
        return {
          completed: currentStepIndex > i,
          step: i + 1,
          active: currentStepIndex === i,
        };
      });
    }, [props.state]);

    return (
      <XStack marginTop={"$small"} gap={"$small"} alignItems="center">
        <CreateWizardBack state={props.state} />
        {dots.map((dot) => (
          <View
            backgroundColor={dot.completed ? "$color" : "$backgroundBlock"}
            key={dot.step}
            borderRadius={5}
            width={10}
            height={10}
            borderWidth={dot.active ? 1 : 0}
            borderColor={"#ccc"}
          />
        ))}
      </XStack>
    );
  });
